import $ from 'jquery';

$('.cw-featurette-d .partner-trigger').on('click', function (e) {
    e.preventDefault();
    const partnerContainer = $(this).next();

    if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        partnerContainer.slideUp(300);
    } else {
        $(this).addClass('open');
        partnerContainer.slideDown(300);
    }
});



// WEBPACK FOOTER //
// ./src/content-widgets/featurette/cw-featurette-d.js